import driver from "../../../assets/driver.png";
import user from "../../../assets/user.png";

const Advantages = () => {
  return (
    <div className="p-6 md:px-16 my-20">
      <div>
        <div className="lg:flex items-center justify-between lg:px-10 max-lg:space-y-10">
          <div className="lg:max-w-[500px]">
            <h1 className="text-4xl leading-[50px] lg:text-5xl lg:leading-[64.48px] text-primaryBlack font-semibold mb-3">
              Make money driving for ZAP
            </h1>
            <span className="text-lg text-paragraph mb-3">
              Unlock the potential of your vehicle and start earning on your own
              schedule with ZAP. With our easy-to-use tools and support,
              becoming a driver has never been easier
            </span>
            <div>
              <button className="w-[160px]">Become a driver</button>
            </div>
          </div>{" "}
          <div className="lg:max-w-[45%]">
            <img src={driver} alt="" />
          </div>
        </div>
        <div className="lg:flex items-center justify-between lg:px-10 my-20 max-lg:space-y-10">
          <div className="lg:max-w-[40%]">
            <img src={user} alt="" />
          </div>
          <div className="lg:max-w-[600px]">
            <h1 className="text-4xl leading-[50px] lg:text-5xl lg:leading-[64.48px] text-primaryBlack font-semibold mb-3">
              Join forces with zap with your fleet
            </h1>
            <span className="text-lg text-paragraph mb-3">
              Add your vehicles to our platform and connect with customers
              looking for hassle-free deliveries and logistics. Together, we can
              revolutionize the way people move and drive the future of
              transportation forward
            </span>
            <div>
              <button className="w-[160px]">Add your fleet</button>
            </div>
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export default Advantages;
